import { Outlet, useParams } from 'react-router-dom'

import { TrainingDetailPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

const DetailRevamp = () => {
  const { id } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data } = useQuery(TrainingDetailPageDocument, {
    variables: {
      trainingId: Number(id),
      resourceId: String(id),
      companyId,
    },
    fetchPolicy: 'cache-only',
  })

  const training = data?.trainings.training
  const trainingClasses = training?.trainingClassesConnection.nodes
  const canEdit = Boolean(training?._policies?.edit.can)
  const hasDevTrainings = Boolean(
    data?.features.featuresConnection.nodes.find(
      (n) => n.name === 'dev_trainings' && n.enabled == true
    )
  )
  const hasContentFF = Boolean(
    data?.features.featuresConnection.nodes.find(
      (n) => n.name === 'dev_training_lms' && n.enabled == true
    )
  )

  return (
    <Outlet
      context={{
        scores: data?.forms.scores,
        classes: trainingClasses,
        training,
        competencies: training?.competenciesConnection.nodes,
        canEdit,
        hasDevTrainings,
        hasContentFF,
      }}
    />
  )
}

export default DetailRevamp
